var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNumber03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2703_57357)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9577 28.5653C18.7204 28.5653 17.6183 28.3526 16.6516 27.9273C15.6905 27.4964 14.9309 26.9053 14.373 26.1541C13.8206 25.3973 13.5361 24.5245 13.5195 23.5357H17.1322C17.1543 23.95 17.2897 24.3146 17.5382 24.6295C17.7923 24.9388 18.1293 25.1791 18.5491 25.3503C18.9689 25.5216 19.4412 25.6072 19.966 25.6072C20.5129 25.6072 20.9963 25.5105 21.4161 25.3172C21.8359 25.1239 22.1646 24.8559 22.4021 24.5135C22.6396 24.171 22.7584 23.776 22.7584 23.3286C22.7584 22.8756 22.6314 22.4751 22.3772 22.1271C22.1287 21.7736 21.7696 21.4974 21.3001 21.2985C20.8361 21.0996 20.2837 21.0002 19.6429 21.0002H18.0603V18.3653H19.6429C20.1842 18.3653 20.6621 18.2713 21.0763 18.0835C21.4962 17.8957 21.8221 17.6361 22.0541 17.3047C22.2861 16.9677 22.4021 16.5755 22.4021 16.128C22.4021 15.7027 22.2999 15.3298 22.0955 15.0094C21.8967 14.6835 21.6149 14.4294 21.2504 14.2471C20.8913 14.0648 20.4715 13.9737 19.9909 13.9737C19.5048 13.9737 19.0601 14.0621 18.6568 14.2388C18.2536 14.4101 17.9304 14.6559 17.6874 14.9763C17.4443 15.2967 17.3145 15.6723 17.2979 16.1032H13.8593C13.8758 15.1254 14.1548 14.2637 14.6961 13.518C15.2375 12.7722 15.9667 12.1894 16.8836 11.7696C17.8061 11.3443 18.8474 11.1316 20.0075 11.1316C21.1785 11.1316 22.2032 11.3443 23.0816 11.7696C23.9599 12.195 24.6421 12.7695 25.1282 13.4931C25.6198 14.2112 25.8629 15.0177 25.8574 15.9126C25.8629 16.8627 25.5674 17.6554 24.9708 18.2907C24.3797 18.9259 23.6091 19.3292 22.659 19.5004V19.633C23.9074 19.7932 24.8575 20.2268 25.5094 20.9339C26.1667 21.6355 26.4926 22.5138 26.4871 23.5689C26.4926 24.5356 26.2137 25.3945 25.6502 26.1458C25.0923 26.8971 24.3217 27.4881 23.3384 27.919C22.3552 28.3499 21.2283 28.5653 19.9577 28.5653Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2703_57357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNumber03);
export default __webpack_public_path__ + "static/media/icon-number-03.be3607e2233f7db621a25e7f5b8d2bbb.svg";
export { ForwardRef as ReactComponent };